import { QueryKey, useQuery, UseQueryOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useAuthentication } from "../auth";
import { getUserPreferences } from "../session-management-api";
import { UserPreferences } from "./types";

export const userPreferencesQueryKey: QueryKey = ["user-preferences"];

export function useUserPreferencesQuery<TData = UserPreferences>(
  options: Omit<
    UseQueryOptions<UserPreferences, AxiosError, TData>,
    "queryKey" | "queryFn"
  > = {},
) {
  const { user } = useAuthentication();

  return useQuery<UserPreferences, AxiosError, TData>({
    queryKey: userPreferencesQueryKey,
    queryFn: () => getUserPreferences(),
    retry: false,
    enabled: !!user,
    ...options,
  });
}
